"use client";

import { c as _c } from "react/compiler-runtime";
import useLocalStorage from "@/hooks/use-local-storage";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Line } from "@/components/line";
import { calculatePaymentSet, getTableData } from "@/features/tools/lib/mortgage";
import { Fragment } from "react";
import { Button } from "@/components/ui/button";
import { PlusIcon, TrashIcon } from "lucide-react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "@/components/ui/table";
import { ToolData } from ".";
function MortgageCalculator(t0) {
  const $ = _c(63);
  const {
    title,
    description
  } = t0;
  const [principal, setPrincipal] = useLocalStorage("mortgage:principal", 500000);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      interestRate: 5,
      payment: 5000,
      offset: 0
    }, {
      interestRate: 4.8,
      payment: 5000,
      offset: 0
    }, {
      interestRate: 5,
      payment: 5000,
      offset: 10000
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [values, setValues] = useLocalStorage("mortgage:values", t1);
  let T0;
  let T1;
  let T2;
  let T3;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== description || $[2] !== principal || $[3] !== setPrincipal || $[4] !== setValues || $[5] !== title || $[6] !== values) {
    let t11;
    if ($[20] !== principal) {
      t11 = value => calculatePaymentSet(principal, value.interestRate, value.payment, value.offset);
      $[20] = principal;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    const paymentSets = values.map(t11);
    const maxSetLength = Math.max(...paymentSets.map(_temp));
    const tableData = getTableData(paymentSets);
    T3 = Card;
    t9 = "mx-auto w-full";
    let t12;
    if ($[22] !== title) {
      t12 = <CardTitle>{title}</CardTitle>;
      $[22] = title;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    let t13;
    if ($[24] !== description) {
      t13 = <CardDescription>{description}</CardDescription>;
      $[24] = description;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    if ($[26] !== t12 || $[27] !== t13) {
      t10 = <CardHeader>{t12}{t13}</CardHeader>;
      $[26] = t12;
      $[27] = t13;
      $[28] = t10;
    } else {
      t10 = $[28];
    }
    T2 = CardContent;
    t4 = "flex w-full flex-col gap-4";
    let t14;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Label>Principal</Label>;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    let t15;
    if ($[30] !== setPrincipal) {
      t15 = e => setPrincipal(parseInt(e.target.value));
      $[30] = setPrincipal;
      $[31] = t15;
    } else {
      t15 = $[31];
    }
    if ($[32] !== principal || $[33] !== t15) {
      t5 = <div className="flex flex-col gap-2">{t14}<Input value={principal} onChange={t15} type="number" min={0} max={10000000} step={1000} /></div>;
      $[32] = principal;
      $[33] = t15;
      $[34] = t5;
    } else {
      t5 = $[34];
    }
    if ($[35] !== principal || $[36] !== setValues || $[37] !== values) {
      t6 = values.map((value_0, index) => <Fragment key={index}><div className="flex flex-row items-end gap-2"><div className="flex flex-col gap-2"><Label>Interest Rate</Label><Input value={isNaN(value_0.interestRate) ? "" : value_0.interestRate} onChange={e_0 => {
              setValues(values.map((v, i) => i === index ? {
                ...v,
                interestRate: parseFloat(e_0.target.value)
              } : v));
            }} type="number" min={0} max={100} step={0.01} /></div><div className="flex flex-1 flex-col gap-2"><Label>Monthly Payment</Label><Input value={isNaN(value_0.payment) ? "" : value_0.payment} onChange={e_1 => {
              setValues(values.map((v_0, i_0) => i_0 === index ? {
                ...v_0,
                payment: parseInt(e_1.target.value)
              } : v_0));
            }} type="number" min={0} max={100000} step={100} /></div><div className="flex flex-1 flex-col gap-2"><Label>Offset</Label><Input value={isNaN(value_0.offset) ? "" : value_0.offset} onChange={e_2 => {
              setValues(values.map((v_1, i_1) => i_1 === index ? {
                ...v_1,
                offset: parseInt(e_2.target.value)
              } : v_1));
            }} type="number" min={0} max={principal} step={1000} /></div><Button size="icon" disabled={values.length === 1} variant="outline" onClick={() => setValues(values.filter((_, i_2) => i_2 !== index))}><TrashIcon className="h-4 w-4" /></Button></div></Fragment>);
      $[35] = principal;
      $[36] = setValues;
      $[37] = values;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    if ($[39] !== setValues || $[40] !== values) {
      t7 = values.length < 5 ? <Button onClick={() => setValues([...values, {
        interestRate: values.length > 0 ? values[values.length - 1].interestRate : 5,
        payment: values.length > 0 ? values[values.length - 1].payment : 5000,
        offset: values.length > 0 ? values[values.length - 1].offset : 0
      }])}>Add <PlusIcon className="h-4 w-4" /></Button> : null;
      $[39] = setValues;
      $[40] = values;
      $[41] = t7;
    } else {
      t7 = $[41];
    }
    t8 = paymentSets.length > 0 ? <Line paymentSets={paymentSets} maxSetLength={maxSetLength} /> : null;
    T1 = Table;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <TableHeader><TableRow><TableCell>Years to 0</TableCell><TableCell>Interest Paid</TableCell></TableRow></TableHeader>;
      $[42] = t3;
    } else {
      t3 = $[42];
    }
    T0 = TableBody;
    t2 = tableData.map(_temp2);
    $[1] = description;
    $[2] = principal;
    $[3] = setPrincipal;
    $[4] = setValues;
    $[5] = title;
    $[6] = values;
    $[7] = T0;
    $[8] = T1;
    $[9] = T2;
    $[10] = T3;
    $[11] = t10;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[7];
    T1 = $[8];
    T2 = $[9];
    T3 = $[10];
    t10 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t11;
  if ($[43] !== T0 || $[44] !== t2) {
    t11 = <T0>{t2}</T0>;
    $[43] = T0;
    $[44] = t2;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== T1 || $[47] !== t11 || $[48] !== t3) {
    t12 = <T1>{t3}{t11}</T1>;
    $[46] = T1;
    $[47] = t11;
    $[48] = t3;
    $[49] = t12;
  } else {
    t12 = $[49];
  }
  let t13;
  if ($[50] !== T2 || $[51] !== t12 || $[52] !== t4 || $[53] !== t5 || $[54] !== t6 || $[55] !== t7 || $[56] !== t8) {
    t13 = <T2 className={t4}>{t5}{t6}{t7}{t8}{t12}</T2>;
    $[50] = T2;
    $[51] = t12;
    $[52] = t4;
    $[53] = t5;
    $[54] = t6;
    $[55] = t7;
    $[56] = t8;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  let t14;
  if ($[58] !== T3 || $[59] !== t10 || $[60] !== t13 || $[61] !== t9) {
    t14 = <T3 className={t9}>{t10}{t13}</T3>;
    $[58] = T3;
    $[59] = t10;
    $[60] = t13;
    $[61] = t9;
    $[62] = t14;
  } else {
    t14 = $[62];
  }
  return t14;
}
function _temp2(data, index_0) {
  return <TableRow key={index_0}><TableCell>{`${data.yearsToZero} years ${data.monthsToZero} months`}</TableCell><TableCell>{data.interestPaid.toFixed(0)}</TableCell></TableRow>;
}
function _temp(paymentSet) {
  return paymentSet.length;
}
export { MortgageCalculator };